var reflectionCCPS = `
#ifdef LIT_CLEARCOAT
void addReflectionCC() {
		ccReflection += calcReflection(ccReflDirW, ccGlossiness);
}
#endif
`;

export { reflectionCCPS as default };
